import React from 'react';
import { useTranslation } from 'react-i18next';
import styles from '../../../../styles/SubscriptionContainer.module.scss';
import { usePurchaseSubscriptionContext } from '../../../../../PurchaseSubscription/context/PurchaseSubscriptionContext';
import Button from '../../../../../../components/Button';
import { SubscriptionAppBarSpacer } from '../../../../components/SubscriptionAppBar';
import { inAppCancellation as events } from '../../../../../../lib/analytics/events';

export default function ResumeMembershipConfirmation() {
  const { t } = useTranslation();
  const { device } = usePurchaseSubscriptionContext();

  return (
    <>
      <div className={styles.fullWidthWrapper}>
        <SubscriptionAppBarSpacer />
        <div className={styles.subscriptionContainer}>
          <h1>{t('your_fi_membership_has_been_resumed')}</h1>
          <p>{t('were_happy_to_have_you_back')}</p>
        </div>

        <div className={styles.buttonContainer}>
          <Button
            className={styles.button}
            onClick={() => {
              events.resumeConfirmationDoneClicked({ petId: device.pet?.id });
              window.open('fi://closeappview?success=Success!%20Your%20membership%20has%20resumed');
            }}
          >
            {t('done')}
          </Button>
          {/* Spacer ensures primary button is aligned with buttons on neighboring pages in in-app cancel flow */}
          <div className={styles.buttonSpacer}></div>
        </div>
      </div>
    </>
  );
}
